var Const = /** @class */ (function () {
    function Const() {
    }
    //===================common-steps=======================
    Const.RUN_STEP1 = '/RUN_STEP1';
    Const.RUN_STEP2 = '/RUN_STEP2';
    Const.SET_STEP2 = '/SET_STEP2';
    Const.GET_STEP2 = '/GET_STEP2';
    Const.RUN_STEP3 = '/RUN_STEP3';
    Const.SET_STEP3 = '/SET_STEP3';
    Const.GET_STEP3 = '/GET_STEP3';
    Const.RUN_GET_STEP_INFO = '/RUN_GET_STEP_INFO';
    Const.RUN_DEL_DOC = '/RUN_DEL_DOC';
    //===================individual-steps====================
    Const.RUN_STEP4 = '/RUN_STEP4';
    Const.RUN_STEP5 = '/RUN_STEP5';
    Const.RUN_STEP6 = '/RUN_STEP6';
    Const.RUN_GENERATE_OTP = '/RUN_GENERATE_OTP';
    //===================corporate-steps=====================	
    Const.RUN_COR_STEP4 = '/RUN_COR_STEP4';
    Const.RUN_COR_STEP5 = '/RUN_COR_STEP5';
    Const.RUN_COR_STEP6 = '/RUN_COR_STEP6';
    Const.RUN_COR_STEP7 = '/RUN_COR_STEP7';
    Const.RUN_GET_IMAGE_OTP = '/RUN_GET_IMAGE_OTP';
    Const.RUN_GET_QUESTION = '/RUN_GET_QUESTION';
    Const.SET_QUESTION = '/SET_QUESTION';
    Const.GET_QUESTION = '/GET_QUESTION';
    Const.RUN_QUESTION = '/RUN_QUESTION';
    Const.RUN_FINANCIAL_QUESTION = '/RUN_FINANCIAL_QUESTION';
    Const.RUN_FINANCIAL_DOCS = '/RUN_FINANCIAL_DOCS';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/registerSteps/provider/lib/const.cls.ts
// module id = FndO
// module chunks = 1